<template>
  <div>
    <div class="clearfix mb-3">
      <div class="float-start">
        <h4 class="card-title">
          {{ $t('setting.list.company.form.bankAccount') }}
        </h4>
      </div>

      <div class="float-end">
        <McButton
          v-if="filterBankSelected.length && hasAccess(['company:update'])"
          v-b-modal.modal-delete-bank
          variant="secondary-red"
          :text="$t('global.delete')"
          icon="icon-outline_trash"
          class="mx-2 mb-2"
        />
        <McButton
          v-if="hasAccess(['company:update'])"
          v-b-modal.addBank
          variant="primary"
          class="mb-2"
          :text="$t('global.addField')"
          icon="icon-fill_plus"
        />
      </div>
    </div>

    <b-card>
      <div class="table-responsive my-3 border border-1">
        <b-table
          small
          show-empty
          :empty-text="$t('global.emptyTable')"
          :empty-filtered-text="$t('global.emptyFilteredTable')"
          :fields="dataBank"
          :items="tData"
          responsive="sm"
          class="datatables"
        >
          <template #head(check)>
            <div class="form-check">
              <input
                v-model="selectAllBank"
                class="form-check-input me-1"
                type="checkbox"
                value="all"
                @input="toggleAllBank"
              />
            </div>
          </template>
          <template #cell(check)="data">
            <div class="form-check">
              <input
                v-model="filterBankSelected"
                class="form-check-input me-1"
                type="checkbox"
                :value="data.item.bankAccountId"
                @input="checkBank"
              />
            </div>
          </template>
          <template #cell(bankName)="data">
            <a href="javascript:void(0)" @click="onRowBankClicked(data.item, data.index)">
              <strong class="text-primary">
                {{ data.item.bankName }}
              </strong>
            </a>
          </template>
          <template #cell(isDefault)="data">
            <div>
              <span
                v-if="data.item.isDefault"
                class="badge rounded-pill font-size-11 badge-soft-success"
              >
                {{ $t('setting.list.company.form.mainBank') }}
              </span>
            </div>
          </template>
        </b-table>
      </div>
    </b-card>

    <b-modal
      id="modal-delete-bank"
      class="mc-modal"
      :title="$t('global.action.delete')"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>
          {{ $t('global.confirmDelete1') }} {{ filterBankSelected.length }}
          {{ $t('global.bankAccounts') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton variant="secondary" :text="$t('global.no')" class="me-2" @click="cancel()" />
            <McButton variant="primary" :text="$t('global.yes')" @click="toDeleteBank" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import { DELETE_BANK_ACCOUNT } from '@/services/api/setting/company/profile'
import { mapGetters } from 'vuex'

export default {
  components: {
    McButton,
  },

  props: {
    tData: {
      type: Array,
      required: true,
    },
    resetModal: {},
  },

  data() {
    return {
      filterBankSelected: [],
      selectAllBank: false,
      bankIndex: null,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    dataBank() {
      return [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'bankName',
          label: this.$t('setting.list.company.form.bankName'),
          sortable: true,
        },
        {
          key: 'accountNo',
          label: this.$t('setting.list.company.form.bankNumber'),
          sortable: true,
        },
        {
          key: 'accountName',
          label: this.$t('setting.list.company.form.bankAccountName'),
          sortable: true,
        },
        {
          key: 'isDefault',
          label: this.$t('setting.list.company.form.statusAccount'),
          sortable: true,
        },
      ]
    },
  },

  methods: {
    checkBank(event) {
      if (event.target.checked) {
        this.filterBankSelected.push(parseInt(event.target.value))
        if (this.filterBankSelected.length == this.tData.length) {
          this.selectAllBank = true
        }
      } else {
        this.selectAllBank = false
        let index = this.filterBankSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterBankSelected.splice(index, 1)
        }
      }
    },
    toggleAllBank(event) {
      let checked = event.target.checked
      this.filterBankSelected = []
      if (checked) {
        this.filterBankSelected = this.tData.map((item) => item.bankAccountId)
      } else {
        this.filterBankSelected = []
      }
    },

    toDeleteBank() {
      let promises = []
      for (let i = 0; i < this.filterBankSelected.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DELETE_BANK_ACCOUNT,
            variables: {
              input: {
                bankAccountId: this.filterBankSelected[i],
              },
            },
          })
        )
      }
      Promise.all(promises).then(() => {
        this.$mcToast.success(this.$t('global.alert.text.delete'))
        this.$emit('clearDelete', 'bank')
        this.$bvModal.hide('modal-delete-bank')
      })
    },

    onRowBankClicked(item, index) {
      if (!this.hasAccess(['company:update'])) return
      this.bankAccounts.bankName = item.bankName
      this.bankAccounts.accountName = item.accountName
      this.bankAccounts.accountNo = item.accountNo
      this.bankAccounts.isDefault = item.isDefault
      this.formEdit = true
      this.bankIndex = index
      this.$bvModal.show('addBank')
    },
  },
}
</script>
